import React, { useEffect, useState } from 'react'
import { AiFillEye, AiFillGithub, AiFillBehanceCircle } from 'react-icons/ai'
import { motion } from 'framer-motion'

import wrapper from '../../utilities/Wrapper'
import { urlFor, client } from '../../utilities/index'
import './Works.scss'
import motionWrapper from '../../utilities/MotionWrapper'

const Works = () => {
  const [activeFilter, setActiveFilter] = useState('All')
  const [animateCard, setAnimateCard] = useState({ y: 0, opacity: 1 })
  const [works, setWorks] = useState([])
  const [filterWorks, setFilterWork] = useState([])

  const handleFilterWorks = item => {
    setActiveFilter(item)
    setAnimateCard([{ y: 100, opacity: 0 }])
    setTimeout(() => {
      setAnimateCard([{ y: 0, opacity: 1 }])
      if (item === 'All') {
        setFilterWork(works.filter((_, index) => index < 11))
      } else {
        setFilterWork(works.filter(work => work.tags.includes(item)))
      }
    }, 500)
  }
  useEffect(() => {
    const query = '*[_type == "works"]'

    client.fetch(query).then(data => {
      setWorks(data.filter((_, index) => index < 11))
      setFilterWork(data.filter((_, index) => index < 11))
    })
  }, [])

  return (
    <>
      <h2 className='head-text dark:text-gray-200'>
        My Creative <span className='dark:text-blue-400'>Portfolio</span>{' '}
        Projects
      </h2>

      <div className='app__work-filter'>
        {['All', 'Front-end', 'React', 'UI/UX'].map((item, i) => (
          <button
            key={i}
            onClick={() => handleFilterWorks(item)}
            className={`app__work-filter-item app__flex p-text ${
              activeFilter === item
                ? 'item-active dark:bg-blue-800 dark:text-white'
                : ''
            }dark:text-white dark:bg-slate-600 dark:hover:bg-blue-800`}
          >
            {item}
          </button>
        ))}
      </div>

      <motion.div
        animate={animateCard}
        transition={{ duration: 0.5, delayChildren: 0.5 }}
        className='app__work-portfolio'
      >
        {filterWorks.length > 0 ? (
          filterWorks.map((work, index) => (
            <div
              className='app__work-item app__flex dark:bg-slate-900'
              key={index}
            >
              <div className='app__work-img app__flex'>
                <img src={urlFor(work.imgUrl)} alt={work.name} />

                <motion.div
                  whileHover={{ opacity: [0, 1] }}
                  transition={{
                    duration: 0.25,
                    ease: 'easeInOut',
                    staggerChildren: 0.5,
                  }}
                  className='app__work-hover app__flex'
                >
                  <a
                    href={work.projectLink}
                    target='_blank'
                    rel='noreferrer'
                    title={work.projectLink}
                  >
                    <motion.div
                      whileInView={{ scale: [0, 1] }}
                      whileHover={{ scale: [1, 0.9] }}
                      transition={{ duration: 0.25 }}
                      className='app__flex'
                    >
                      <AiFillEye />
                    </motion.div>
                  </a>
                  <a
                    href={work.codeLink}
                    target='_blank'
                    rel='noreferrer'
                    title={work.codeLink}
                  >
                    <motion.div
                      whileInView={{ scale: [0, 1] }}
                      whileHover={{ scale: [1, 0.9] }}
                      transition={{ duration: 0.25 }}
                      className='app__flex'
                    >
                      {work.tags[0] === 'UI/UX' ? (
                        <AiFillBehanceCircle />
                      ) : (
                        <AiFillGithub />
                      )}
                    </motion.div>
                  </a>
                </motion.div>
              </div>

              <div className='app__work-content app__flex'>
                <h4 className='bold-text dark:text-white'>{work.title}</h4>
                <p
                  className='p-text work-description dark:text-slate-400'
                  style={{ marginTop: 10 }}
                >
                  {work.description}
                </p>

                <div className='app__work-tag dark:bg-slate-900 app__flex'>
                  <p className='p-text dark:text-white'>{work?.tags[0]}</p>
                </div>

                <div className='app__work-tags_skills '>
                  {work.tags.map((tag, i) => (
                    <p
                      key={i}
                      className='app__work-tags__tag dark:text-slate-400 dark:bg-slate-800'
                    >
                      #{tag}
                    </p>
                  ))}
                </div>
              </div>
            </div>
          ))
        ) : (
          <p>There Is no Project Yet</p>
        )}
      </motion.div>
    </>
  )
}

export default wrapper(
  motionWrapper(Works, 'app__works'),
  'work',
  'app__primarybg dark:bg-slate-800'
)
